import { PILLARS } from '../constants';

export function pillarById(id) {
  return PILLARS.find((p) => p.id === id) || null;
}

export function humanDuration(seconds) {
  if (!seconds && seconds !== 0) return '—';
  const m = Math.round(seconds / 60);
  if (m < 1) return `${seconds}s`;
  if (m === 1) return '1 min';
  return `${m} min`;
}

export function daysUntil(iso) {
  if (!iso) return null;
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return null;
  const diffMs = then - Date.now();
  return Math.max(0, Math.ceil(diffMs / (24 * 60 * 60 * 1000)));
}
